import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { ClassEventService } from "../../../services/class-event.service";
import { TAttendedClassEvent } from "../../../models/ClassEvent";

export const useGetAttendedClassEventsReservationsQuery = () => {
  return useQuery<TAttendedClassEvent[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ATTENDED_CLASS_EVENTS_RESERVATIONS],
    queryFn: () => ClassEventService.getAttendedClassEvents().then((res) => res.data),
  });
};
